import React from "react";
import Header from "../core/Blocks/Header";
import Footer from "../core/Blocks/Footer";
import CookieBanner from "./CookieConsents/CookieConsent";

interface Props {
  children: React.ReactNode;
}

const Layout: React.FC<Props> = ({ children }) => (
  <>
    <Header />
    <main>{children}</main>
    <Footer />
    <CookieBanner />
  </>
);

export default Layout;
